class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange(e) {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.updateInventoryStatus();
    this.removeErrorMessage();
    this.updateVariantStatuses();
    this.filterImgVariant();
    this.activeMediaIndicators();
    this.hideInactiveDots();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  filterImgVariant() {
  console.clear();
  console.log(this.currentVariant);

  if (this.currentVariant.featured_image && this.currentVariant.featured_image.alt) {
    // Show only the thumbnails of the selected color
    document.querySelectorAll("[thumbnail-alt]").forEach(img => img.style.display = "none");

    const currentImageAlt = this.currentVariant.featured_image.alt;
    const thumbnailSelector = `[thumbnail-alt='${currentImageAlt}']`;

    document.querySelectorAll(thumbnailSelector).forEach(img => img.style.display = "block");
  } else {
    // Show All thumbnails
    document.querySelectorAll("[thumbnail-alt]").forEach(img => img.style.display = "block");
  }
}

  hideInactiveDots() {
    let thumbanilsIndicator = document.querySelectorAll(".dots-wrapper .dot");
    let allProductMedia = document.querySelectorAll(".gridy-slider.product-media-slider.medium-up-hide-custom.large-hide-custom .product-media");

    let displayBlockedThumbnails = [];

    allProductMedia.forEach(media => {
      if (getComputedStyle(media).display === 'block') {
        displayBlockedThumbnails.push(media);
      }
    });

    console.clear();
    console.log(displayBlockedThumbnails);

    thumbanilsIndicator.forEach(indicator => {
      indicator.style.display = 'none';
      indicator.classList.remove('active');
    });

    displayBlockedThumbnails.forEach((displayedThumbnail, index) => {
      thumbanilsIndicator.forEach((indicator, indicatorIndex) => {
        if (displayedThumbnail.getAttribute('data-slide-custom') === indicator.getAttribute('data-slide-custom')) {
          indicator.style.display = 'block';
          if (index === 0 && indicatorIndex === 0) {
            indicator.classList.add('active');
          }
        }
      });
    });


    
  }

  activeMediaIndicators() {
const slides = document.querySelectorAll(".product-media");
const options = { threshold: 0 };

const handleIntersection = (entries, observer) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      requestAnimationFrame(() => {
        entry.target.classList.add('active-in-viewport');
        let attributeValue = entry.target.getAttribute("data-slide-custom");
        document.querySelector(`.dot[data-slide-custom="${attributeValue}"]`).classList.add("active");
      });
    } else {
      requestAnimationFrame(() => {
        let attributeValue = entry.target.getAttribute("data-slide-custom");
        document.querySelector(`.dot[data-slide-custom="${attributeValue}"]`).classList.remove("active");
        entry.target.classList.remove('active-in-viewport');
      });
    }
  });
};

const observer = new IntersectionObserver(handleIntersection, options);

slides.forEach(slide => {
  observer.observe(slide);
});
  }

  

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGridySlider = document.getElementById(`slider-${this.dataset.section}`);
    const thumbnailsGridySlider = document.getElementById(`thumbnail-slider-${this.dataset.section}`);
    
    if (mediaGridySlider) {
      mediaGridySlider.scrollToSlideByID(
        `item-${this.currentVariant.featured_media.id}`
      );
    }
    
    if (thumbnailsGridySlider) {
      thumbnailsGridySlider.scrollToSlideByID(`thumbnail-item-${this.currentVariant.featured_media.id}`)
    }
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}, #product-form-${this.dataset.section}-product-buy-bar`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(variant => this.querySelector(':checked').value === variant.option1);
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')]
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants.filter(variant => variant.available && variant[`option${ index }`] === previousOptionSelected).map(variantOption => variantOption[`option${ index + 1 }`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue)
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  updateInventoryStatus() {
    this.productInventoryNode = document.querySelector('[data-product-inventory]');

    if (!this.productInventoryNode || !window.inventories || !window.inventories[this.dataset.productId]) return;

    this.inventoryThreshold = parseInt(this.productInventoryNode.dataset.threshold);
    this.showQuantityInStock = this.productInventoryNode.dataset.showQuantityInStock;

    const variantInventoryObject = window.inventories[this.dataset.productId][this.currentVariant?.id];

    if (!this.currentVariant || !this.currentVariant.inventory_management) {
      this.toggleInventoryQuantity(false);
      this.toggleIncomingInventory(false);

      return;
    }

    if (this.currentVariant.inventory_management === 'shopify') {
      if (variantInventoryObject.quantity <= 0 && variantInventoryObject.incoming === 'true' && variantInventoryObject.quantity < this.inventoryThreshold) {
        this.toggleInventoryQuantity(false);
        this.toggleIncomingInventory(true, variantInventoryObject.next_incoming_date);
      } else {
        this.toggleInventoryQuantity(true, variantInventoryObject.quantity);
        this.toggleIncomingInventory(false);
      }
    }
  }

  toggleInventoryQuantity(show, quantity) {
    if (show === false) {
      this.productInventoryNode.classList.add('hide');
      return;
    }

    this.productInventoryNode.classList.remove('inventory-status--in-stock', 'inventory-status--low', 'inventory-status--sold-out', 'inventory-status--sold-out-continue-selling');

    if (this.currentVariant && this.currentVariant.available && parseInt(quantity) <= parseInt(this.inventoryThreshold) && parseInt(quantity) > 0) {
      this.productInventoryNode.classList.add('inventory-status--low');
      if (!this.showQuantityInStock === 'true') {
        this.productInventoryNode.firstElementChild.textContent = window.variantStrings.inventory.few_left_with_quantity.replace('[quantity]', quantity);
      } else {
        this.productInventoryNode.firstElementChild.textContent = window.variantStrings.inventory.few_left;
      }
    } else if (this.currentVariant && this.currentVariant.available && parseInt(quantity) > parseInt(this.inventoryThreshold)) {
      this.productInventoryNode.classList.add('inventory-status--in-stock');
      if (!this.showQuantityInStock === 'true') {
        this.productInventoryNode.firstElementChild.textContent = window.variantStrings.inventory.in_stock_with_quantity.replace('[quantity]', quantity);
      } else {
        this.productInventoryNode.firstElementChild.textContent = window.variantStrings.inventory.in_stock;
      }
    } else if (this.currentVariant && this.currentVariant.available && parseInt(quantity) < 1) {
      this.productInventoryNode.classList.add('inventory-status--sold-out-continue-selling');
      this.productInventoryNode.firstElementChild.textContent = window.variantStrings.inventory.out_of_stock_continue_selling;
    } else {
      this.productInventoryNode.classList.add('inventory-status--sold-out');
      this.productInventoryNode.firstElementChild.textContent = window.variantStrings.inventory.out_of_stock;
    }

    this.productInventoryNode.classList.remove('hide');
  }

  toggleIncomingInventory(show, date) {
    const incomingInventoryNode = document.querySelector('[data-incoming-inventory]');
    if (!incomingInventoryNode) return;

    if (show == false && incomingInventoryNode) {
      incomingInventoryNode.classList.add('hide');

      return;
    }

    let string = !date ?
      window.variantStrings.inventory.waiting_for_stock : 
      window.variantStrings.inventory.will_be_in_stock_after.replace('[date]', date);

    incomingInventoryNode.classList.remove('hide');
    incomingInventoryNode.firstElementChild.textContent = string;
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const destinationBuyBarInfo = document.getElementById(
          `buy-bar-info-${this.dataset.section}`
        );
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const buyBarInfoSource = html.getElementById(`buy-bar-info-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        if (source && destination) destination.innerHTML = source.innerHTML;
        if (source && destinationBuyBarInfo) destinationBuyBarInfo.innerHTML = buyBarInfoSource.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
        this.toggleBackInStock();
      });
  }

  toggleBackInStock() {
    if (!window.ALYSI_BIS) return;
    if (this.currentVariant && !this.currentVariant.available) {
      const productTitle = document.querySelector('.product__title')?.textContent?.trim() || '';
      const variantTitle = this.currentVariant.title !== 'Default Title' ? this.currentVariant.title : '';
      const name = variantTitle ? (productTitle + ' - ' + variantTitle) : productTitle;
      window.ALYSI_BIS.prepare(this.currentVariant.id, name);
    } else {
      window.ALYSI_BIS.hide();
    }
  }

  getAvailableAddButtonText() {
    if (this.dataset.isWok == 'true') {
      return window.variantStrings.preOrderNow;
    }
    if (this.dataset.isPreorder == 'true') {
      return window.variantStrings.preOrder;
    }
    return window.variantStrings.addToCart;
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const bisText = window.variantStrings.notifyWhenAvailable;
    const availableText = this.getAvailableAddButtonText();
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      // During variant switching we temporarily disable the button; avoid BIS text flicker.
      // BIS behavior is only enabled when the selected variant is truly sold out.
      if (this.currentVariant && this.currentVariant.available === false) {
        addButton.removeAttribute('disabled');
        addButton.setAttribute('type', 'button');
        addButton.setAttribute('data-bis-trigger', 'true');
        if (addButtonText) addButtonText.textContent = bisText;
      } else {
        addButton.setAttribute('disabled', 'disabled');
        addButton.setAttribute('type', 'submit');
        addButton.removeAttribute('data-bis-trigger');
        if (addButtonText) {
          addButtonText.textContent = availableText || addButtonText.textContent;
        }
      }
    } else {
      addButton.removeAttribute('disabled');
      addButton.setAttribute('type', 'submit');
      addButton.removeAttribute('data-bis-trigger');
      if (addButtonText) addButtonText.textContent = availableText;
    }

    const productForm_BuyBar = document.getElementById(
      `product-form-${this.dataset.section}-product-buy-bar`
    );
    if (productForm_BuyBar) {
      const addButton_BuyBar = productForm_BuyBar.querySelector('[name="add"]');
      const addButtonText_BuyBar = productForm_BuyBar.querySelector(
        '[name="add"] > span'
      );

      if (disable) {
        if (this.currentVariant && this.currentVariant.available === false) {
          addButton_BuyBar.removeAttribute("disabled");
          addButton_BuyBar.setAttribute('type', 'button');
          addButton_BuyBar.setAttribute('data-bis-trigger', 'true');
          if (addButtonText_BuyBar) addButtonText_BuyBar.textContent = bisText;
        } else {
          addButton_BuyBar.setAttribute("disabled", "disabled");
          addButton_BuyBar.setAttribute('type', 'submit');
          addButton_BuyBar.removeAttribute('data-bis-trigger');
          if (addButtonText_BuyBar) {
            addButtonText_BuyBar.textContent = availableText || addButtonText_BuyBar.textContent;
          }
        }
      } else {
        addButton_BuyBar.removeAttribute("disabled");
        addButton_BuyBar.setAttribute('type', 'submit');
        addButton_BuyBar.removeAttribute('data-bis-trigger');
        if (addButtonText_BuyBar) addButtonText_BuyBar.textContent = availableText;
      }
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('hidden');

    const button_BuyBar = document.getElementById(
      `product-form-${this.dataset.section}-product-buy-bar`
    );
    const addButton_BuyBar = button_BuyBar.querySelector('[name="add"]');
    const addButtonText_BuyBar = button_BuyBar.querySelector(
      '[name="add"] > span'
    );
    const price_BuyBar = document.getElementById(
      `price-${this.dataset.section}-product-buy-bar`
    );
    if (!addButton_BuyBar) return;
    addButtonText_BuyBar.textContent = window.variantStrings.unavailable;
    if (price_BuyBar) price_BuyBar.classList.add("hidden");
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
    this.syncSizeNoticeVisibility();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });

    this.updateLegends();
  }

  updateLegends() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    fieldsets.forEach((fieldset) => {
      const legend = fieldset.querySelector('legend [data-variant-legend]');
      const selectedOption = Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked);
      if (!legend || !selectedOption) return;
      legend.textContent = selectedOption.dataset.displayValue || selectedOption.getAttribute('value');
      legend.classList.remove('variant-legend--pending');
      legend.classList.add('variant-legend--ready');
    });
  }

  updateVariantStatuses() {
    super.updateVariantStatuses();
    this.syncSizeNoticeVisibility();
  }

  syncSizeNoticeVisibility() {
    const notice = this.querySelector('[data-size-notice]');
    if (!notice) return;

    const sizeFieldset = notice.closest('fieldset');
    if (!sizeFieldset) return;

    const hasUnavailableSize = Boolean(sizeFieldset.querySelector('input[type="radio"].disabled'));
    notice.hidden = !hasUnavailableSize;
  }
}

customElements.define('variant-radios', VariantRadios);

// Store product handles to history for "recently-viewed" section.
(function() {
  const history = sessionStorage.getItem('Woolman_Product_History') ? sessionStorage.getItem('Woolman_Product_History').split(',') : [];
  const productHandle = window.location.pathname.split('/').pop();
  if (!productHandle) return;
  if (!history.includes(productHandle)) {

    if (history.length >= 10) { // only store up to 10 recently viewed products
      history.shift();
    }
    
    history.push(productHandle);
    sessionStorage.setItem('Woolman_Product_History', history.join(','));
  }
})();

class ProductBuyBar extends HTMLElement {
  constructor() {
    "use strict";
    super();

    let classes = { show: "show" };
    let mainProductForm = document.querySelector(".product-form");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // In view -> Hide bar
            this.classList.remove(classes.show);
          } else if (window.scrollY > 200) {
            // Out of view AND scrolled a little from top -> Show bar
            this.classList.add(classes.show);
          }
        });
      },
      { threshold: 0.25 }
    );

    observer.observe(mainProductForm);

    // This script is loaded in product-template.liquid --> Footer observer after DOM ready
    document.addEventListener("DOMContentLoaded", function () {
      let siteFooter = document.querySelector("footer.footer");
      if (!siteFooter) return;
      observer.observe(siteFooter);
    });
  }
}
customElements.define("product-buy-bar", ProductBuyBar);

class UpsellCard extends HTMLElement {
  constructor() {
    super();
    this.select = this.querySelector('select');
    this.image = this.querySelector('.card-media img');

    if (this.select) {
      this.select.addEventListener('change', (event) => {
        const selectedOption = event.target.options[event.target.selectedIndex];
        const newImgSrc = selectedOption.getAttribute('data-variant-img-src');
        this.updateImage(newImgSrc);
      });
    }
  }

  updateImage(newImgSrc) {
    if (this.image) {
      this.image.src = newImgSrc;
    }
  }
}

customElements.define('upsell-card', UpsellCard);

(function () {
  const showDurationMs = 3500;

  const revealSizeNotice = () => {
    const notice = document.querySelector('[data-size-notice]');
    if (!notice || notice.hidden) return;

    requestAnimationFrame(() => {
      notice.classList.add('is-visible');

      window.setTimeout(() => {
        notice.classList.remove('is-visible');
        notice.classList.add('is-hidden');
      }, showDurationMs);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', revealSizeNotice);
  } else {
    revealSizeNotice();
  }
})();

// Product image zoom + navigation (all devices)
// - Open on click/tap
// - Navigate with swipe (touch) or arrows / keyboard
// - Tablet: pinch + pan, double tap to toggle zoom
(function () {
  function clamp(n, min, max) {
    return Math.max(min, Math.min(max, n));
  }

  function dist(t1, t2) {
    const dx = t1.clientX - t2.clientX;
    const dy = t1.clientY - t2.clientY;
    return Math.sqrt(dx * dx + dy * dy);
  }

  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  onReady(() => {
    const overlay = document.querySelector('[data-product-zoom-overlay]');
    if (!overlay) return;

    const stage = overlay.querySelector('[data-zoom-stage]');
    const img = overlay.querySelector('[data-zoom-img]');
    const btnClose = overlay.querySelector('[data-zoom-close]');
    const btnPrev = overlay.querySelector('[data-zoom-prev]');
    const btnNext = overlay.querySelector('[data-zoom-next]');

    if (!stage || !img) return;

    let items = [];
    let index = 0;

    // transform state
    let scale = 1;
    let tx = 0;
    let ty = 0;

    // swipe state
    let swipeStartX = 0;
    let swipeStartY = 0;
    let swipeStartT = 0;

    // pinch state
    let pinchStartDist = 0;
    let pinchStartScale = 1;

    // pan state
    let panActive = false;
    let panStartX = 0;
    let panStartY = 0;

    // double tap
    let lastTapT = 0;
    let lastTapX = 0;
    let lastTapY = 0;

    function setTransform() {
      img.style.transform = `translate3d(${tx}px, ${ty}px, 0) scale(${scale})`;
    }

    function resetZoom() {
      scale = 1;
      tx = 0;
      ty = 0;
      img.style.transformOrigin = '50% 50%';
      setTransform();
    }

    function visibleGalleryRoot() {
      // Desktop + mobile sliders are both in DOM; pick the one that's visible.
      const sliders = Array.from(document.querySelectorAll('.product-media-slider'));
      return sliders.find((s) => getComputedStyle(s).display !== 'none') || document;
    }

    function collectItems() {
      const root = visibleGalleryRoot();
      items = Array.from(root.querySelectorAll('[data-product-zoom-item]'))
        .filter((el) => {
          const media = el.closest('.product-media');
          return !media || getComputedStyle(media).display !== 'none';
        })
        .map((el) => {
          const insideImg = el.querySelector('img');
          return {
            src: el.getAttribute('data-zoom-src'),
            alt: insideImg ? insideImg.getAttribute('alt') || '' : '',
          };
        })
        .filter((it) => !!it.src);
    }

    function load(i) {
      const it = items[i];
      if (!it) return;
      img.src = it.src;
      img.alt = it.alt || '';
      resetZoom();
    }

    function openAt(i) {
      collectItems();
      if (!items.length) return;

      index = clamp(i, 0, items.length - 1);
      overlay.hidden = false;
      document.documentElement.classList.add('product-zoom-open');
      load(index);
    }

    function close() {
      overlay.hidden = true;
      document.documentElement.classList.remove('product-zoom-open');
      resetZoom();
    }

    function next() {
      if (items.length < 2) return;
      index = (index + 1) % items.length;
      load(index);
    }

    function prev() {
      if (items.length < 2) return;
      index = (index - 1 + items.length) % items.length;
      load(index);
    }

    // Open handler: click/tap on product image
    document.addEventListener('click', (e) => {
      const item = e.target.closest('[data-product-zoom-item]');
      if (!item) return;

      e.preventDefault();

      const raw = item.getAttribute('data-zoom-index') || '1';
      const i = Math.max(1, parseInt(raw, 10)) - 1;
      openAt(i);
    });

    btnClose?.addEventListener('click', close);
    btnNext?.addEventListener('click', (e) => {
      e.stopPropagation();
      next();
    });
    btnPrev?.addEventListener('click', (e) => {
      e.stopPropagation();
      prev();
    });

    // Close on backdrop click (not on image/stage)
    overlay.addEventListener('click', (e) => {
      if (e.target === overlay) close();
    });

    // Keyboard navigation
    document.addEventListener('keydown', (e) => {
      if (overlay.hidden) return;
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowRight') next();
      if (e.key === 'ArrowLeft') prev();
    });

    // Touch gestures
    stage.addEventListener(
      'touchstart',
      (e) => {
        if (overlay.hidden) return;

        if (e.touches.length === 1) {
          swipeStartX = e.touches[0].clientX;
          swipeStartY = e.touches[0].clientY;
          swipeStartT = Date.now();

          if (scale > 1) {
            panActive = true;
            panStartX = swipeStartX - tx;
            panStartY = swipeStartY - ty;
          }
        }

        if (e.touches.length === 2) {
          e.preventDefault();
          pinchStartDist = dist(e.touches[0], e.touches[1]);
          pinchStartScale = scale;
          panActive = false;
        }
      },
      { passive: false }
    );

    stage.addEventListener(
      'touchmove',
      (e) => {
        if (overlay.hidden) return;

        if (e.touches.length === 2) {
          e.preventDefault();
          const d = dist(e.touches[0], e.touches[1]);
          scale = clamp(pinchStartScale * (d / pinchStartDist), 1, 3);
          if (scale === 1) {
            tx = 0;
            ty = 0;
          }
          setTransform();
          return;
        }

        if (e.touches.length === 1 && panActive && scale > 1) {
          e.preventDefault();
          tx = e.touches[0].clientX - panStartX;
          ty = e.touches[0].clientY - panStartY;
          setTransform();
        }
      },
      { passive: false }
    );

    stage.addEventListener(
      'touchend',
      (e) => {
        if (overlay.hidden) return;

        const now = Date.now();
        const ended = e.changedTouches && e.changedTouches[0];

        // double tap toggles zoom on touch devices
        if (ended) {
          const dx = Math.abs(ended.clientX - lastTapX);
          const dy = Math.abs(ended.clientY - lastTapY);
          const isDouble = now - lastTapT < 300 && dx < 24 && dy < 24;

          lastTapT = now;
          lastTapX = ended.clientX;
          lastTapY = ended.clientY;

          if (isDouble) {
            if (scale === 1) {
              scale = 2;
              img.style.transformOrigin = '50% 50%';
              setTransform();
            } else {
              resetZoom();
            }
            panActive = false;
            return;
          }
        }

        panActive = false;

        // Swipe navigation only when not zoomed (avoid conflicts with pan)
        if (scale !== 1 || !ended) return;

        const endX = ended.clientX;
        const endY = ended.clientY;
        const dt = now - swipeStartT;

        const deltaX = endX - swipeStartX;
        const deltaY = endY - swipeStartY;

        if (Math.abs(deltaX) > 55 && Math.abs(deltaY) < 40 && dt < 650) {
          if (deltaX < 0) next();
          else prev();
        }
      },
      { passive: true }
    );
  });
})();